import React, { useState, useEffect } from 'react';

const badge = {
  display: 'inline-flex', alignItems: 'center', gap: '8px',
  background: 'rgba(45,106,79,0.15)', border: '1px solid rgba(82,183,136,0.3)',
  borderRadius: '100px', padding: '6px 16px',
  fontSize: '13px', color: '#52b788', fontWeight: 500, marginBottom: '32px',
};

const dot = {
  width: '7px', height: '7px', borderRadius: '50%',
  background: '#52b788', animation: 'pulse 2s infinite',
};

const headingPrimary = {
  fontFamily: "'Space Grotesk', sans-serif",
  fontSize: 'clamp(44px, 6vw, 80px)',
  fontWeight: 800, lineHeight: 1.05,
  letterSpacing: '-2px', color: '#fff',
};

const headingAccent = {
  fontFamily: "'Space Grotesk', sans-serif",
  fontSize: 'clamp(44px, 6vw, 80px)',
  fontWeight: 800, lineHeight: 1.05,
  letterSpacing: '-2px',
  background: 'linear-gradient(90deg, #52b788, #2d6a4f)',
  WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
};

const subText = {
  fontSize: '18px', color: '#a8b4cc', lineHeight: 1.7,
  maxWidth: '540px', marginTop: '24px',
};

const btnPrimary = {
  background: 'linear-gradient(135deg, #2d6a4f, #40916c)',
  color: '#fff', padding: '16px 36px', borderRadius: '10px',
  fontSize: '16px', fontWeight: 600, border: 'none', cursor: 'pointer',
  transition: 'transform 0.2s, box-shadow 0.2s',
  boxShadow: '0 8px 32px rgba(45,106,79,0.4)',
};

const btnSecondary = {
  background: 'transparent', color: '#a8b4cc',
  padding: '16px 36px', borderRadius: '10px',
  fontSize: '16px', fontWeight: 500,
  border: '1px solid rgba(255,255,255,0.12)', cursor: 'pointer',
  transition: 'border-color 0.2s, color 0.2s',
};

const mockWindow = {
  background: '#0f1628', borderRadius: '14px',
  border: '1px solid rgba(255,255,255,0.08)',
  overflow: 'hidden', boxShadow: '0 40px 80px rgba(0,0,0,0.6)',
};

const mockBar = {
  background: '#141c35', padding: '12px 16px',
  display: 'flex', alignItems: 'center', gap: '8px',
  borderBottom: '1px solid rgba(255,255,255,0.06)',
};

const dot2 = (c) => ({ width: '10px', height: '10px', borderRadius: '50%', background: c });

const tableRow = (even) => ({
  display: 'grid', gridTemplateColumns: '180px 130px 1fr 120px 90px',
  gap: '12px', padding: '12px 16px', fontSize: '12px',
  background: even ? 'rgba(255,255,255,0.015)' : 'transparent',
  borderBottom: '1px solid rgba(255,255,255,0.04)',
  alignItems: 'center',
});

const badge2 = (color) => ({
  display: 'inline-block', padding: '2px 10px', borderRadius: '100px',
  fontSize: '11px', fontWeight: 600,
  background: color === 'green' ? 'rgba(82,183,136,0.15)' : color === 'yellow' ? 'rgba(251,191,36,0.15)' : 'rgba(239,68,68,0.15)',
  color: color === 'green' ? '#52b788' : color === 'yellow' ? '#fbbf24' : '#ef4444',
});

export default function Hero() {
  const [tick, setTick] = useState(0);
  useEffect(() => { const t = setInterval(() => setTick(p => p + 1), 3000); return () => clearInterval(t); }, []);

  const rows = [
    { id: 'SR-2026-0124', user: 'Swati Agarwal', title: 'VPN Access Issue', state: 'In Progress', priority: 'High', pColor: 'red' },
    { id: 'SR-2026-0123', user: 'Rahul Singh', title: 'Email Config', state: 'Resolved', priority: 'Low', pColor: 'green' },
    { id: 'SR-2026-0122', user: 'Satish Verma', title: 'DB Backup Failure', state: 'Re-Open', priority: 'Medium', pColor: 'yellow' },
    { id: 'SR-2026-0121', user: 'Priya Nair', title: 'Laptop Setup', state: 'Open', priority: 'High', pColor: 'red' },
  ];

  return (
    <section style={{ paddingTop: '120px', paddingBottom: '80px', position: 'relative', overflow: 'hidden' }}>
      {/* Glow blobs */}
      <div style={{ position: 'absolute', top: '-120px', left: '-120px', width: '500px', height: '500px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(45,106,79,0.18) 0%, transparent 70%)', pointerEvents: 'none' }} />
      <div style={{ position: 'absolute', bottom: '0', right: '0', width: '400px', height: '400px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(82,183,136,0.08) 0%, transparent 70%)', pointerEvents: 'none' }} />

      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 32px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '64px', alignItems: 'center' }} className="hero-grid">
          {/* Left */}
          <div>
            <div style={badge}>
              <span style={dot} /> Enterprise ITSM Platform
            </div>
            <h1 style={headingPrimary}>Resolve faster.<br /></h1>
            <h1 style={headingAccent}>Serve smarter.</h1>
            <p style={subText}>
              ATLAS ITSM is a full-suite IT Service Management platform by Aiprus Software — built for enterprises that need real control over incidents, service requests, changes, and more, with role-based access, SLA enforcement, and transparent workflows.
            </p>
            <div style={{ display: 'flex', gap: '16px', marginTop: '40px', flexWrap: 'wrap' }}>
              <button style={btnPrimary}
                onMouseEnter={e => { e.target.style.transform = 'translateY(-2px)'; e.target.style.boxShadow = '0 12px 40px rgba(45,106,79,0.5)'; }}
                onMouseLeave={e => { e.target.style.transform = 'none'; e.target.style.boxShadow = '0 8px 32px rgba(45,106,79,0.4)'; }}
                onClick={() => document.getElementById('book-a-demo').scrollIntoView({ behavior: 'smooth' })}>
                Book a Free Demo
              </button>
              <button style={btnSecondary}
                onMouseEnter={e => { e.target.style.borderColor = 'rgba(82,183,136,0.4)'; e.target.style.color = '#fff'; }}
                onMouseLeave={e => { e.target.style.borderColor = 'rgba(255,255,255,0.12)'; e.target.style.color = '#a8b4cc'; }}
                onClick={() => document.getElementById('features').scrollIntoView({ behavior: 'smooth' })}>
                Explore Features →
              </button>
            </div>
          </div>

          {/* Right — mock UI */}
          <div style={mockWindow}>
            <div style={mockBar}>
              <span style={dot2('#ef4444')} />
              <span style={dot2('#fbbf24')} />
              <span style={dot2('#22c55e')} />
              <span style={{ marginLeft: '10px', fontSize: '12px', color: '#5a6a8a' }}>ATLAS ITSM — Service Requests</span>
            </div>
            <div style={{ padding: '0' }}>
              {/* Table header */}
              <div style={{ ...tableRow(false), color: '#5a6a8a', fontWeight: 600, fontSize: '11px', letterSpacing: '0.05em', textTransform: 'uppercase', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
                <span>Ticket ID</span><span>Requested By</span><span>Title</span><span>State</span><span>Priority</span>
              </div>
              {rows.map((r, i) => (
                <div key={r.id} style={tableRow(i % 2 === 0)}>
                  <span style={{ color: '#52b788', fontWeight: 600 }}>{r.id}</span>
                  <span style={{ color: '#a8b4cc' }}>{r.user}</span>
                  <span style={{ color: '#fff' }}>{r.title}</span>
                  <span style={badge2(r.state === 'Resolved' ? 'green' : r.state === 'In Progress' ? 'yellow' : 'red')}>{r.state}</span>
                  <span style={badge2(r.pColor)}>{r.priority}</span>
                </div>
              ))}
            </div>
            <div style={{ padding: '12px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: '1px solid rgba(255,255,255,0.06)' }}>
              <span style={{ fontSize: '11px', color: '#5a6a8a' }}>4 of 247 tickets · SLA Active</span>
              <span style={{ fontSize: '11px', color: '#52b788', fontWeight: 600 }}>● Live</span>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes pulse { 0%,100%{opacity:1} 50%{opacity:0.4} }
        @media(max-width:900px){ .hero-grid{ grid-template-columns:1fr !important; } }
      `}</style>
    </section>
  );
}
